import axios from "axios";
import day from 'dayjs'

export default {
    state: {
        estimates: [],
        queryOptions: {
            prevKey: 'orders.id',
            queryKey: 'orders.id',
            queryOrder: 'desc',
            queryText: null,
            page: 1
        },
    },
    mutations: {
        setEstimates: function(state, payload) {
            state.estimates = payload
        },
        setEstimateQueryOptions: function(state, payload) {
            state.queryOption = payload
        }
    },
    getters: {
        getEstimateQueryOptions: async function(state) {
          return state.queryOptions
        },
        getEstimates: async function(state) {
            return state.estimates
        }
    },
    actions: {
        async getEstimates({ state, commit }) {

            const queryOptions = state.queryOptions

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: this.getters.getApiUrl + '/api/v1/order/getEstimates',
                data: queryOptions,
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.status != '9999') {

                    const tmpResult = response.data
                    const tmpEstimates = []

                    let i = 0
                    for (const item of response.data.data) {

                        item.estimateDate = day(item.estimateDate).format('YY/MM/DD')
                        item.dueDate = day(item.dueDate).format('YY/MM/DD')

                        tmpEstimates[i] = item

                        i++

                    }

                    tmpResult.data = tmpEstimates

                    commit('setEstimates', tmpResult)

                }else{

                    commit('setEstimates', [])

                }

            })

        },
        setEstimateQueryOptions({ commit }, payload) {
            commit('setEstimateQueryOptions', payload)
        },
    }
}